var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"question-image"},[_c('img',{staticClass:"image-src",attrs:{"src":_vm.asset,"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }